<template>
  <div class="view not-found">
    <div class="view-content" ref="viewContent">
      <h1>☹️ 404</h1>
    </div>
  </div>
</template>

<script>
import { TweenMax } from "gsap/TweenMax";

export default {
  beforeRouteLeave(to, from, next) {
    TweenMax.to(this.$refs.viewContent, 0.3, {
      opacity: 0,
      ease: Cubic.easeInOut,
      onComplete: next
    });
  }
};
</script>


<style lang="scss" scoped>
.view {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  @media (max-width: 375px) {
    padding-top: 80px;
  }
}
</style>
